import { render, staticRenderFns } from "./AdditionalReport.vue?vue&type=template&id=b38748f4&scoped=true"
import script from "./AdditionalReport.vue?vue&type=script&lang=js"
export * from "./AdditionalReport.vue?vue&type=script&lang=js"
import style0 from "./AdditionalReport.vue?vue&type=style&index=0&id=b38748f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38748f4",
  null
  
)

export default component.exports